import React from 'react';
function MountPluginHook(_ref) {
  var usePluginHook = _ref.usePluginHook,
    editorView = _ref.editorView,
    containerElement = _ref.containerElement;
  usePluginHook({
    editorView: editorView,
    containerElement: containerElement
  });
  return null;
}
export function MountPluginHooks(_ref2) {
  var pluginHooks = _ref2.pluginHooks,
    editorView = _ref2.editorView,
    containerElement = _ref2.containerElement;
  if (!editorView) {
    return null;
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, pluginHooks === null || pluginHooks === void 0 ? void 0 : pluginHooks.map(function (usePluginHook, key) {
    return /*#__PURE__*/React.createElement(MountPluginHook
    // Ignored via go/ees005
    // eslint-disable-next-line react/no-array-index-key
    , {
      key: key,
      usePluginHook: usePluginHook,
      editorView: editorView,
      containerElement: containerElement
    });
  }));
}